import ConfigurationCheck from './ConfigurationCheck'

export default ConfigurationCheck
